import { useRef, useState } from 'react';
import {
    DEFAULT_SORT,
    NO_PATIENT_FILTERS,
    type PatientFilters,
} from '../model';

/** The search and filters a list was last queried under. */
type ListScope = { search: string; filters: PatientFilters };

/**
 * The patient list's search input, sort, filters and selected patient, held
 * by the caller so they outlive a list that is unmounted and shown again.
 * `scopeRef` holds the scope the selection was made under, so a scope changed
 * while the list was hidden still clears it.
 */
export function usePatientListState() {
    const [searchInput, setSearchInput] = useState('');
    const [sort, setSort] = useState(DEFAULT_SORT);
    const [filters, setFilters] = useState(NO_PATIENT_FILTERS);
    const [selectedId, setSelectedId] = useState<string>();
    const scopeRef = useRef<ListScope>({
        search: '',
        filters: NO_PATIENT_FILTERS,
    });
    return {
        scopeRef,
        searchInput,
        setSearchInput,
        sort,
        setSort,
        filters,
        setFilters,
        selectedId,
        setSelectedId,
    };
}

export type PatientListState = ReturnType<typeof usePatientListState>;
